export default __webpack_public_path__ + "static/media/login.e97b9f18.png";